import { render, staticRenderFns } from "./DataConversionYMinYMax.vue?vue&type=template&id=8ec33720&scoped=true&"
import script from "./DataConversionYMinYMax.vue?vue&type=script&lang=js&"
export * from "./DataConversionYMinYMax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec33720",
  null
  
)

/* custom blocks */
import block0 from "./DataConversionYMinYMax.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports